import { useQuery } from "@tanstack/react-query";
import { pontoApi } from "@/features/ponto/pontoApi";
import { SelectCadastroRh, type SelectCadastroRhProps } from "./SelectCadastroRh";

/** Departamento do RH (cadastro em RH / Ponto → Departamentos). */
export function DepartamentoSelect({ rotuloNenhum = "Sem departamento", placeholder = "Departamento", ...props }: SelectCadastroRhProps) {
  const { data = [] } = useQuery({ queryKey: ["ponto-departamentos"], queryFn: () => pontoApi.departamentos(false), staleTime: 60_000 });
  const opcoes = data.map((d) => ({ id: d.id, rotulo: d.sNome, detalhe: d.sSigla || undefined, ativo: d.ibAtivo }));
  return <SelectCadastroRh {...props} rotuloNenhum={rotuloNenhum} placeholder={placeholder} opcoes={opcoes} />;
}

/** Cargo/função do RH (cadastro em RH / Ponto → Cargos). */
export function CargoSelect({ rotuloNenhum = "Sem cargo", placeholder = "Cargo", ...props }: SelectCadastroRhProps) {
  const { data = [] } = useQuery({ queryKey: ["ponto-cargos"], queryFn: () => pontoApi.cargos(false), staleTime: 60_000 });
  const opcoes = data.map((c) => ({ id: c.id, rotulo: c.sNome, detalhe: c.sCbo ? `CBO ${c.sCbo}` : undefined, ativo: c.ibAtivo }));
  return <SelectCadastroRh {...props} rotuloNenhum={rotuloNenhum} placeholder={placeholder} opcoes={opcoes} />;
}
